




















import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';

import Countdown from './Countdown.vue';

export default defineComponent({
  name: 'WebsiteBannerCountdown',
  components: {
    BaseButton,
    Countdown,
  },
  props: {
    websiteBanner: {
      type: Object,
      required: true,
    },
    linkText: {
      type: String,
      default: 'CHECK IT OUT',
    },
  },
  computed: {
    hasCountdownTime(): boolean {
      return !!this.countdownTime;
    },
    countdownTime(): string {
      return this.websiteBanner?.countdownTime || '';
    },
    heading(): string {
      return this.websiteBanner?.title || '';
    },
    bannerHeadingClasses() {
      const baseClass = 'website-banner-countdown__heading';
      const showClass = `${baseClass}--show`;
      return [baseClass, { [showClass]: !this.hasCountdownTime }];
    },
  },
});
